import React, { useState, useEffect } from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined, CheckCircleFilled, WarningFilled } from '@ant-design/icons';
import { Divider, Row, Col, Steps, Form } from 'antd';
import { TAMenu, TASteps, FormSectionTitle, Title, TAMenuItem } from '../dashboard/styles';
import { ButtonType, TAButton } from '../widgets';
import { useTheme } from 'styled-components';
export function MultStepForm({
	onMenueSelect,
	children: steps,
	onNext,
	onPrev,
	current,
	onFinish,
	showMenu,
	form
}: any): any {
	let [currentStep, setCurrentStep] = useState(current ?? 0);
	const theme = useTheme();

	useEffect(() => {
		setCurrentStep(current);
	}, [current]);
	const stepsCount = steps.filter(c => c.type === MultStepForm.Step).length;
	const gotNextCallback =
		nextStep =>
		(goNext = true) => {
			if (goNext) setCurrentStep(nextStep);
		};
	const next = () => {
		const nextStep = (currentStep + 1) % stepsCount;
		onNext ? onNext(currentStep, nextStep, gotNextCallback(nextStep)) : setCurrentStep(nextStep);
	};

	const prev = async () => {
		const prevStep = (currentStep - 1) % stepsCount;
		onPrev ? onPrev(currentStep, prevStep, gotNextCallback(prevStep)) : setCurrentStep(prevStep);
	};

	const getStepValidationIcon = step => {
		let stepStatus = step.props.status;
		return stepStatus === 'error' ? errorIcon : stepStatus === 'done' ? checkIcon : null;
	};

	const errorIcon = <WarningFilled style={{ color: '#ff4d4f', fontSize: '14px', marginLeft: 'auto' }} />;
	const checkIcon = <CheckCircleFilled style={{ color: theme.TA_GREEN, fontSize: '14px', marginLeft: 'auto' }} />;

	return (
		<Row className="d-flex justify-content-center mx-auto ta-job-form-container">
			{showMenu && (
				<Col xs={0} lg={4}>
					<TAMenu
						mode="inline"
						selectedKeys={[`step-${currentStep}`]}
						className="mt-5"
						onSelect={sel => {
							//TODO: check this
							const stepIndex = +sel.key[sel.key.length - 1];
							onMenueSelect(currentStep, stepIndex, gotNextCallback(stepIndex));
							setCurrentStep(stepIndex);
						}}
					>
						{steps.map((step, indx) => (
							<TAMenuItem
								key={`step-${indx}`}
								// index={indx}
							>
								<div className="d-flex justify-content-between align-items-center">
									{step.props.menuItem ? (
										step.props.menuItem
									) : (
										<span>{step.props.title || `Step ${indx}`}</span>
									)}
									{getStepValidationIcon(step)}
								</div>
							</TAMenuItem>
						))}
					</TAMenu>
				</Col>
			)}

			<Col xs={24} lg={showMenu ? 20 : undefined}>
				<Row className="px-md-5 ta-job-form-content">
					<TASteps current={currentStep}>
						{steps.map((step, indx) => (
							<Steps.Step
								key={step.props.key || step.props.title}
								status={step.props.status !== 'error' ? undefined : 'error'}
							/>
						))}
					</TASteps>
					<div className="steps-content w-100">
						<Form
							layout="vertical"
							className="ta-form py-3"
							labelAlign="left"
							onFinish={onFinish}
							onFinishFailed={e => {
								console.log(e);
							}}
							form={form}
						>
							{steps.map((step, indx) => (
								<fieldset
									className="ta-form-section"
									style={{ display: currentStep === indx ? 'block' : 'none' }}
								>
									{step.props.title && <FormSectionTitle>{step.props.title}</FormSectionTitle>}
									{step}
								</fieldset>
							))}
							<Divider />

							<div className="steps-action d-flex justify-content-between pb-3">
								{currentStep > 0 && (
									<TAButton btntype={ButtonType.PRIMARY} style={{ margin: '0 8px' }} onClick={prev}>
										<span className="d-flex justify-content-between align-items-center">
											<ArrowLeftOutlined /> <span className="ms-1">Previous</span>
										</span>
									</TAButton>
								)}
								{currentStep === steps.length - 1 && (
									<TAButton btntype={ButtonType.PRIMARY} htmlType="submit">
										<span className="d-flex justify-content-between align-items-center">
											<span className="me-1">Post</span>
											<CheckCircleFilled />
										</span>
									</TAButton>
								)}
								{currentStep < steps.length - 1 && (
									<TAButton btntype={ButtonType.PRIMARY} className="ms-auto" onClick={next}>
										<span className="d-flex justify-content-between align-items-center">
											<span className="me-1">Next</span>
											<ArrowRightOutlined />
										</span>
									</TAButton>
								)}
							</div>
						</Form>
					</div>
				</Row>
			</Col>
		</Row>
	);
}

MultStepForm.Step = ({ key, status, children, title, menuItem }: any) => {
	return children;
};
